import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ImageService } from "../service/app.image.service";
import { Thumb } from '../models/thumb.model';
import { Archive } from '../models/archive.model';
import { Search } from '../models/search.model';

@Component({
    selector: "app-camera-archive",
    templateUrl: "./app.camera.archive.component.html"
})
export class CameraArchiveComponent implements OnInit, OnDestroy {
    id: string;
    private sub: any;
    private _imageService: ImageService;
    public data: Archive;
    public activeImage: Thumb;
    public current: number = 0;
    public year: number;
    public month: number;
    public hasDate: boolean = false;

    constructor(private route: ActivatedRoute, private im: ImageService) {
        this._imageService = im;
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        let date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.onLoadData();
    }

    open(index: number): void {
        this.current = index;
        this.onSetActive();
    }

    onPrevClick(index: number) {
        this.current = this.data.thumbs.findIndex(x => x.id == index) - 1;
        if (this.current <= 0)
            this.current = this.data.thumbs.length - 1;

        this.activeImage = this.data.thumbs[this.current];
        this.hasDate = this.activeImage.imageDate.length > 0;

    }

    onNextClick(index: number) {
        this.current = this.data.thumbs.findIndex(x => x.id == index) + 1;
        if (this.current >= this.data.thumbs.length)
            this.current = 0;

        this.activeImage = this.data.thumbs[this.current];
        this.hasDate = this.activeImage.imageDate.length > 0;
    }

    onChangeYear(year) {
        this.year = year;
        this.onLoadData();
    }

    onChange(month) {
        this.month = month;
        this.onLoadData();
    }

    private onSetActive() {
        let active = this.data.thumbs.find(x => x.id == this.current);
        if (active !== undefined) {
            this.activeImage = active;
            this.hasDate = this.activeImage.imageDate.length > 0;
        }
    }

    private onLoadData() {
        this.data = new Archive();
        let model = new Search();
        this.activeImage = new Thumb();
        model.month = this.month;
        model.year = this.year;
        model.name = this.id;

        this._imageService.onGetArchive(model)
            .subscribe(s => {
                let d = s.json();
                this.data = d;

                if (this.data.thumbs.length > 0)
                    this.activeImage.id = this.data.thumbs[0].id;

                this.activeImage.realPath = this.data.current;
            });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}


// WEBPACK FOOTER //
// C:/pgutev/work/WEBCAM/src/app/camera/app.camera.archive.component.ts